import { FormInstance } from "antd";

import { ScheduleRepeatFormFields } from "@/pages/SV/RouteManagement/components/ScheduleRepeatForm/ScheduleRepeatForm.types";
import { PageBlock } from "@/shared/pageComposition/BlockList";

import { AddPointCapabilities } from "./AddPoint.policy";
import { AddPointControlsBlock } from "./blocks/AddPointControlsBlock";
import { AddPointListBlock } from "./blocks/AddPointListBlock";
import { AddPointScheduleFormBlock } from "./blocks/AddPointScheduleFormBlock";
import { StyledScrollContainer } from "./Styled";

export type AddPointModel = {
    capabilities: AddPointCapabilities;
    bootLoading: boolean;
    updateLoading: boolean;
    scheduleRepeatForm: FormInstance<ScheduleRepeatFormFields>;
    checkedPoints: Set<string>;
    handlers: {
        togglePointChecked: (pointId: string) => void;
        handleUpdatePoint: () => void;
        handleCreatePoint: () => void;
    };
};

export const getAddPointBlocks = (
    model: AddPointModel,
): PageBlock<AddPointModel>[] => [
    {
        key: "add-point-main-content",
        order: 10,
        render: () => (
            <StyledScrollContainer vertical gap={12}>
                <AddPointScheduleFormBlock form={model.scheduleRepeatForm} />
                <AddPointListBlock
                    bootLoading={model.bootLoading}
                    checkedPoints={model.checkedPoints}
                    onTogglePointChecked={model.handlers.togglePointChecked}
                />
            </StyledScrollContainer>
        ),
    },
    {
        key: "add-point-controls",
        order: 20,
        render: () => (
            <AddPointControlsBlock
                checkedPointsCount={model.checkedPoints.size}
                updateLoading={model.updateLoading}
                onUpdatePoint={model.handlers.handleUpdatePoint}
                onCreatePoint={model.handlers.handleCreatePoint}
            />
        ),
    },
];
